export default {
  title: 'Pré-encomenda',
  categories: {
    title: 'Mais Popular',
  },
  header: {
    pickup: 'Levantamento em 5 Minutos',
  },
};
